import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import InteractiveStudio from "@/components/InteractiveStudio";

export default function InteractiveManualPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [interactive, setInteractive] = useState(null);

  useEffect(() => {
    api.get(`/manuals/${id}`)
      .then((r) => setInteractive(r.data.interactive || {}))
      .catch(() => { toast.error("Handleiding niet gevonden"); navigate("/manuals"); });
  }, [id, navigate]);

  if (interactive === null) return <div className="min-h-screen flex items-center justify-center bg-kann-base"><Loader2 className="w-6 h-6 animate-spin text-kann-gold" /></div>;

  return (
    <InteractiveStudio
      manualId={id}
      initial={interactive}
      onClose={() => navigate(`/manuals/${id}`)}
      onSaved={() => {}}
    />
  );
}
